/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Github from '../../assets/icons/Github';
import Linkedin from '../../assets/icons/Linkedin';
import Mail from '../../assets/icons/Mail';
import Medium from '../../assets/icons/Medium';

import classes from './LeftBar.module.css';

const leftBar = () => {
  return (
    <div className={classes.LeftBar}>
      <h1>
        Hi.
        <br />
        I'm <span style={{ color: 'white' }}>Rajat Srivastava</span>.
        <br />A Software Engineer / Web Developer.
      </h1>
      <ul>
        <li>
          <a href="https://github.com/rajat-sr" target="_blank" rel="noopener noreferrer">
            <Github height="25" width="25" />
          </a>
        </li>
        <li>
          <a href="https://medium.com/@rajat_sriv" target="_blank" rel="noopener noreferrer">
            <Medium height="25" width="25" />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/rajat-srivastava-720604122/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin height="25" width="25" />
          </a>
        </li>
        <li>
          <a
            href="mailto:rajat.srivastava.20893@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Mail height="25" width="25" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default leftBar;
